function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoFoundPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-82"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M726.35,203.73C709.45,127,650.63,66.37,570.53,46.07c-21.06-5.33-43.46-8-65.75-5.73C413.69,49.72,305,111,248.65,123.86S126.16,85.31,51.19,164.25-6.47,425.84,143.45,461.63s233.36-52.31,300-33,185.81,11,256.21-45.89C741.35,349,741,270.35,726.35,203.73Z",
    style: {
      fill: "#0D6EFD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.35,203.73C709.45,127,650.63,66.37,570.53,46.07c-21.06-5.33-43.46-8-65.75-5.73C413.69,49.72,305,111,248.65,123.86S126.16,85.31,51.19,164.25-6.47,425.84,143.45,461.63s233.36-52.31,300-33,185.81,11,256.21-45.89C741.35,349,741,270.35,726.35,203.73Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bricks--inject-82"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 374.76,
    y: 221.52,
    width: 30.88,
    height: 12.5,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363,
    y: 177.04,
    width: 30.88,
    height: 12.5,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.26,
    y: 221.15,
    width: 30.88,
    height: 12.5,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.1,
    y: 134.19,
    width: 30.88,
    height: 12.5,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.92,
    y: 134.19,
    width: 30.88,
    height: 12.5,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.33,
    y: 313.56,
    width: 30.88,
    height: 12.5,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.16,
    y: 329,
    width: 30.88,
    height: 12.5,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.09,
    y: 194.32,
    width: 30.88,
    height: 12.5,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.4,
    y: 264.52,
    width: 30.88,
    height: 12.5,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.56,
    y: 283.64,
    width: 30.88,
    height: 12.5,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.85,
    y: 283.64,
    width: 30.88,
    height: 12.5,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.79,
    y: 265.99,
    width: 30.88,
    height: 12.5,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.37,
    y: 194.32,
    width: 30.88,
    height: 12.5,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.85,
    y: 94.8,
    width: 30.88,
    height: 12.5,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.09,
    y: 50.32,
    width: 30.88,
    height: 12.5,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.18,
    y: 67.6,
    width: 30.88,
    height: 12.5,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372.47,
    y: 67.6,
    width: 30.88,
    height: 12.5,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.48,
    y: 327.74,
    width: 30.88,
    height: 12.5,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.58,
    y: 345.02,
    width: 30.88,
    height: 12.5,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.86,
    y: 345.02,
    width: 30.88,
    height: 12.5,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.81,
    y: 172.2,
    width: 30.88,
    height: 12.5,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.9,
    y: 189.47,
    width: 30.88,
    height: 12.5,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.18,
    y: 189.47,
    width: 30.88,
    height: 12.5,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.76,
    y: 265.26,
    width: 30.88,
    height: 12.5,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.49,
    y: 205.5,
    width: 30.88,
    height: 12.5,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.18,
    y: 328.27,
    width: 30.88,
    height: 12.5,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.74,
    y: 118.76,
    width: 30.88,
    height: 12.5,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.11,
    y: 223.88,
    width: 30.88,
    height: 12.5,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.76,
    y: 208.44,
    width: 30.88,
    height: 12.5,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.41,
    y: 133.3,
    width: 30.88,
    height: 12.5,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.74,
    y: 221.52,
    width: 30.88,
    height: 12.5,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480.15,
    y: 221.52,
    width: 30.88,
    height: 12.5,
    transform: "translate(991.17 455.53) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 491.91,
    y: 177.04,
    width: 30.88,
    height: 12.5,
    transform: "translate(1014.7 366.58) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 603.65,
    y: 221.15,
    width: 30.88,
    height: 12.5,
    transform: "translate(1238.17 454.8) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 558.81,
    y: 134.19,
    width: 30.88,
    height: 12.5,
    transform: "translate(1148.49 280.88) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 524.99,
    y: 134.19,
    width: 30.88,
    height: 12.5,
    transform: "translate(1080.86 280.88) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 508.82,
    y: 194.32,
    width: 30.88,
    height: 12.5,
    transform: "translate(1048.51 401.13) rotate(180)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 462.51,
    y: 264.52,
    width: 30.88,
    height: 12.5,
    transform: "translate(955.89 541.54) rotate(180)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 643.35,
    y: 283.64,
    width: 30.88,
    height: 12.5,
    transform: "translate(1317.57 579.77) rotate(180)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 608.06,
    y: 283.64,
    width: 30.88,
    height: 12.5,
    transform: "translate(1246.99 579.77) rotate(180)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 605.12,
    y: 265.99,
    width: 30.88,
    height: 12.5,
    transform: "translate(1241.11 544.48) rotate(180)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 473.53,
    y: 194.32,
    width: 30.88,
    height: 12.5,
    transform: "translate(977.94 401.13) rotate(180)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.74,
    y: 377.47,
    width: 30.88,
    height: 12.5,
    transform: "translate(496.36 767.43) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.65,
    y: 394.74,
    width: 30.88,
    height: 12.5,
    transform: "translate(530.18 801.98) rotate(180)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.36,
    y: 394.74,
    width: 30.88,
    height: 12.5,
    transform: "translate(459.6 801.98) rotate(180)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.29,
    y: 377.47,
    width: 30.88,
    height: 12.5,
    transform: "translate(197.45 767.43) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.2,
    y: 394.74,
    width: 30.88,
    height: 12.5,
    transform: "translate(231.27 801.98) rotate(180)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.91,
    y: 394.74,
    width: 30.88,
    height: 12.5,
    transform: "translate(160.7 801.98) rotate(180)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 565.42,
    y: 327.74,
    width: 30.88,
    height: 12.5,
    transform: "translate(1161.72 667.98) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 582.33,
    y: 345.02,
    width: 30.88,
    height: 12.5,
    transform: "translate(1195.54 702.53) rotate(180)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 547.04,
    y: 345.02,
    width: 30.88,
    height: 12.5,
    transform: "translate(1124.96 702.53) rotate(180)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 590.42,
    y: 205.5,
    width: 30.88,
    height: 12.5,
    transform: "translate(1211.71 423.5) rotate(180)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 636.73,
    y: 328.27,
    width: 30.88,
    height: 12.5,
    transform: "translate(1304.33 669.03) rotate(180)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 486.12,
    y: 345.84,
    width: 30.88,
    height: 12.5,
    transform: "translate(1003.11 704.17) rotate(180)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450.83,
    y: 345.84,
    width: 30.88,
    height: 12.5,
    transform: "translate(932.54 704.17) rotate(180)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.19,
    y: 389.94,
    width: 30.88,
    height: 12.5,
    transform: "translate(847.26 792.38) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 671.97,
    y: 407.22,
    width: 30.88,
    height: 12.5,
    transform: "translate(1374.81 826.94) rotate(180)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 671.97,
    y: 375.26,
    width: 30.88,
    height: 12.5,
    transform: "translate(1374.81 763.01) rotate(180)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 687.79,
    y: 390.81,
    width: 30.88,
    height: 12.5,
    transform: "translate(1406.45 794.11) rotate(180)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 652.37,
    y: 390.81,
    width: 30.88,
    height: 12.5,
    transform: "translate(1335.61 794.11) rotate(180)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 479.5,
    y: 390.47,
    width: 30.88,
    height: 12.5,
    transform: "translate(989.88 793.43) rotate(180)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 519.96,
    y: 431.91,
    width: 30.88,
    height: 12.5,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 503.05,
    y: 449.19,
    width: 30.88,
    height: 12.5,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 538.34,
    y: 449.19,
    width: 30.88,
    height: 12.5,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 622.76,
    y: 420.89,
    width: 30.88,
    height: 12.5,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 605.85,
    y: 449.19,
    width: 30.88,
    height: 12.5,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 641.14,
    y: 449.19,
    width: 30.88,
    height: 12.5,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.29,
    y: 461.67,
    width: 30.88,
    height: 12.5,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.58,
    y: 445.25,
    width: 30.88,
    height: 12.5,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.56,
    y: 429.7,
    width: 30.88,
    height: 12.5,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.74,
    y: 445.25,
    width: 30.88,
    height: 12.5,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.16,
    y: 445.25,
    width: 30.88,
    height: 12.5,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 541.16,
    y: 118.76,
    width: 30.88,
    height: 12.5,
    transform: "translate(1113.2 250.01) rotate(180)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 524.75,
    y: 66.06,
    width: 30.88,
    height: 12.5,
    transform: "translate(1080.37 144.61) rotate(180)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648.49,
    y: 133.3,
    width: 30.88,
    height: 12.5,
    transform: "translate(1327.86 279.1) rotate(180)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 541.16,
    y: 221.52,
    width: 30.88,
    height: 12.5,
    transform: "translate(1113.2 455.53) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.19,
    y: 48.45,
    width: 30.88,
    height: 12.5,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.45,
    y: 137,
    width: 30.88,
    height: 12.5,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.95,
    y: 147.78,
    width: 30.88,
    height: 12.5,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.49,
    y: 160.1,
    width: 30.88,
    height: 12.5,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.27,
    y: 160.66,
    width: 30.88,
    height: 12.5,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.3,
    y: 65.97,
    width: 30.88,
    height: 12.5,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 508.06,
    y: 48.45,
    width: 30.88,
    height: 12.5,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 489.16,
    y: 65.97,
    width: 30.88,
    height: 12.5,
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pipelines--inject-82"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.21,213.38H11.56v-13H84.71V12.2h13V206.88A6.5,6.5,0,0,1,91.21,213.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.21,213.88H11.56a.5.5,0,0,1-.5-.5v-13a.5.5,0,0,1,.5-.5H84.21V12.2a.5.5,0,0,1,.5-.5h13a.51.51,0,0,1,.5.5V206.88A7,7,0,0,1,91.21,213.88Zm-79.15-1H91.21a6,6,0,0,0,6-6V12.7h-12V200.38a.5.5,0,0,1-.5.5H12.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.25,7.74V82.17H97.43v13H673.37v314.2H519.75a6.5,6.5,0,0,0-6.5,6.5v47.86h13V422.37H673.37v44h13V95.17h14.38a6.5,6.5,0,0,0,6.5-6.5V7.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.37,466.84h-13a.5.5,0,0,1-.5-.5V422.87H526.75v40.86a.5.5,0,0,1-.5.5h-13a.5.5,0,0,1-.5-.5V415.87a7,7,0,0,1,7-7H672.87V95.67H97.43a.5.5,0,0,1-.5-.5v-13a.5.5,0,0,1,.5-.5H693.75V7.74a.5.5,0,0,1,.5-.5h13a.5.5,0,0,1,.5.5V88.67a7,7,0,0,1-7,7H686.87V466.34A.5.5,0,0,1,686.37,466.84Zm-12.5-1h12V95.17a.5.5,0,0,1,.5-.5h14.38a6,6,0,0,0,6-6V8.24h-12V82.17a.5.5,0,0,1-.5.5H97.93v12H673.37a.5.5,0,0,1,.5.5v314.2a.5.5,0,0,1-.5.5H519.75a6,6,0,0,0-6,6v47.36h12V422.37a.5.5,0,0,1,.5-.5H673.37a.5.5,0,0,1,.5.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 694.44,
    y: 47.8,
    width: 12.7,
    height: 5.9,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.14,54.2h-12.7a.5.5,0,0,1-.5-.5V47.8a.5.5,0,0,1,.5-.5h12.7a.5.5,0,0,1,.5.5v5.9A.5.5,0,0,1,707.14,54.2Zm-12.2-1h11.7V48.3h-11.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 562.8,
    y: 412.98,
    width: 12.7,
    height: 5.9,
    transform: "translate(985.08 -153.22) rotate(90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.1,422.78h-5.9a.5.5,0,0,1-.5-.5v-12.7a.5.5,0,0,1,.5-.5h5.9a.5.5,0,0,1,.5.5v12.7A.5.5,0,0,1,572.1,422.78Zm-5.4-1h4.9v-11.7h-4.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 575.65,
    y: 412.98,
    width: 12.7,
    height: 5.9,
    transform: "translate(997.93 -166.07) rotate(90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585,422.78h-5.9a.5.5,0,0,1-.5-.5v-12.7a.5.5,0,0,1,.5-.5H585a.5.5,0,0,1,.5.5v12.7A.5.5,0,0,1,585,422.78Zm-5.4-1h4.9v-11.7h-4.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.94,
    y: 433.07,
    width: 209.64,
    height: 13,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.58,446.57H29.94a.51.51,0,0,1-.5-.5v-13a.5.5,0,0,1,.5-.5H239.58a.5.5,0,0,1,.5.5v13A.5.5,0,0,1,239.58,446.57Zm-209.14-1H239.08v-12H30.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.94,
    y: 415.15,
    width: 209.64,
    height: 13,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.58,428.65H29.94a.5.5,0,0,1-.5-.5v-13a.51.51,0,0,1,.5-.5H239.58a.5.5,0,0,1,.5.5v13A.5.5,0,0,1,239.58,428.65Zm-209.14-1H239.08v-12H30.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.38,
    y: 415.4,
    width: 8.97,
    height: 12.63,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.34,428.53h-9a.5.5,0,0,1-.5-.5V415.4a.5.5,0,0,1,.5-.5h9a.5.5,0,0,1,.5.5V428A.5.5,0,0,1,128.34,428.53Zm-8.46-1h8V415.9h-8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.06,
    y: 415.4,
    width: 8.97,
    height: 12.63,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147,428.53h-9a.5.5,0,0,1-.5-.5V415.4a.5.5,0,0,1,.5-.5h9a.5.5,0,0,1,.5.5V428A.5.5,0,0,1,147,428.53Zm-8.46-1h8V415.9h-8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.38,
    y: 433.31,
    width: 8.97,
    height: 12.63,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.34,446.44h-9a.5.5,0,0,1-.5-.5V433.31a.5.5,0,0,1,.5-.5h9a.5.5,0,0,1,.5.5v12.63A.5.5,0,0,1,128.34,446.44Zm-8.46-1h8V433.81h-8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.06,
    y: 433.31,
    width: 8.97,
    height: 12.63,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147,446.44h-9a.5.5,0,0,1-.5-.5V433.31a.5.5,0,0,1,.5-.5h9a.5.5,0,0,1,.5.5v12.63A.5.5,0,0,1,147,446.44Zm-8.46-1h8V433.81h-8Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gears--inject-82"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M268.08,172.49V155.34H257.64a50.41,50.41,0,0,0-2.22-8.34l9-5.2L255.87,127l-9,5.22a50.21,50.21,0,0,0-6.1-6.1l5.22-9-14.85-8.57-5.21,9a48.52,48.52,0,0,0-8.34-2.22V104.84H200.4v10.44a49.42,49.42,0,0,0-8.34,2.21l-5.21-9L172,117l5.23,9a48.82,48.82,0,0,0-6.1,6.1l-9-5.22-8.57,14.85,9,5.21a49.42,49.42,0,0,0-2.21,8.34H149.89v17.14h10.45a49.42,49.42,0,0,0,2.21,8.34l-9,5.21,8.57,14.85,9.05-5.22a50,50,0,0,0,6.09,6.09l-5.21,9,14.84,8.58,5.22-9a48.93,48.93,0,0,0,8.34,2.21V223h17.14V212.58a49.45,49.45,0,0,0,8.34-2.22l5.21,9L246,210.81l-5.22-9a50.85,50.85,0,0,0,6.09-6.1l9,5.22L264.45,186l-9-5.21a49.42,49.42,0,0,0,2.21-8.34ZM209,195.87a31.95,31.95,0,1,1,31.94-31.94A31.94,31.94,0,0,1,209,195.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.57,223.52H200.42a.5.5,0,0,1-.5-.5V213a50.05,50.05,0,0,1-7.61-2l-5,8.67a.51.51,0,0,1-.69.18l-14.84-8.57a.51.51,0,0,1-.19-.69l5-8.67a52.31,52.31,0,0,1-5.57-5.57l-8.68,5a.5.5,0,0,1-.38,0,.52.52,0,0,1-.3-.23l-8.57-14.85a.5.5,0,0,1,.18-.68l8.66-5a49.87,49.87,0,0,1-2-7.62h-10a.5.5,0,0,1-.5-.5V155.37a.5.5,0,0,1,.5-.5h10a50.18,50.18,0,0,1,2-7.62l-8.66-5a.51.51,0,0,1-.19-.68l8.58-14.85a.48.48,0,0,1,.3-.24.55.55,0,0,1,.38,0l8.68,5a50.33,50.33,0,0,1,5.56-5.56l-5-8.69a.53.53,0,0,1,0-.37.56.56,0,0,1,.23-.31L186.6,108a.51.51,0,0,1,.69.18l5,8.66a49.74,49.74,0,0,1,7.61-2v-10a.5.5,0,0,1,.5-.5h17.15a.51.51,0,0,1,.5.5v10a49.74,49.74,0,0,1,7.61,2l5-8.66A.48.48,0,0,1,231,108a.47.47,0,0,1,.38,0l14.85,8.57a.49.49,0,0,1,.18.68l-5,8.68a50.51,50.51,0,0,1,5.57,5.57l8.68-5a.55.55,0,0,1,.38-.05.48.48,0,0,1,.3.24l8.57,14.84a.51.51,0,0,1-.18.69l-8.66,5a49.74,49.74,0,0,1,2,7.61h10a.51.51,0,0,1,.5.5v17.15a.51.51,0,0,1-.5.5h-10a49.74,49.74,0,0,1-2,7.61l8.66,5a.48.48,0,0,1,.24.3.56.56,0,0,1-.05.38l-8.58,14.85a.49.49,0,0,1-.68.18l-8.68-5a51.3,51.3,0,0,1-5.56,5.57l5,8.68a.49.49,0,0,1-.18.68l-14.85,8.58a.56.56,0,0,1-.38.05.48.48,0,0,1-.3-.24l-5-8.66a50.94,50.94,0,0,1-7.61,2v10A.5.5,0,0,1,217.57,223.52Zm-16.65-1h16.15v-9.94a.51.51,0,0,1,.41-.5,47.52,47.52,0,0,0,8.26-2.19.5.5,0,0,1,.6.22l5,8.59,14-8.07-5-8.61a.52.52,0,0,1,.11-.64,49.86,49.86,0,0,0,6-6,.48.48,0,0,1,.63-.11l8.61,5,8.07-14-8.59-5a.49.49,0,0,1-.22-.6,49.63,49.63,0,0,0,2.19-8.26.49.49,0,0,1,.49-.41h9.94V155.84h-9.94a.5.5,0,0,1-.5-.41,48.31,48.31,0,0,0-2.19-8.25.51.51,0,0,1,.22-.61l8.59-5-8.07-14-8.61,5a.52.52,0,0,1-.64-.11,49.86,49.86,0,0,0-6-6,.49.49,0,0,1-.12-.63l5-8.6-14-8.08-5,8.6a.51.51,0,0,1-.61.22,47.41,47.41,0,0,0-8.25-2.19.5.5,0,0,1-.41-.5v-9.94H200.9v10a.49.49,0,0,1-.41.49,49.12,49.12,0,0,0-8.26,2.19.49.49,0,0,1-.6-.22l-5-8.59-14,8.08,5,8.61a.51.51,0,0,1-.11.63,49.23,49.23,0,0,0-6,6,.5.5,0,0,1-.63.11l-8.61-5-8.07,14,8.59,5a.5.5,0,0,1,.22.61,49.26,49.26,0,0,0-2.19,8.25.5.5,0,0,1-.49.42h-9.94V172h10a.5.5,0,0,1,.49.42,49.26,49.26,0,0,0,2.19,8.25.49.49,0,0,1-.22.6l-8.59,5,8.08,14,8.61-5a.5.5,0,0,1,.63.12,49.86,49.86,0,0,0,6,6,.51.51,0,0,1,.11.63l-5,8.61,14,8.07,5-8.59a.51.51,0,0,1,.61-.22,49.26,49.26,0,0,0,8.25,2.19.49.49,0,0,1,.41.49ZM209,196.38a32.45,32.45,0,1,1,32.44-32.45A32.48,32.48,0,0,1,209,196.38Zm0-63.9a31.45,31.45,0,1,0,31.44,31.45A31.49,31.49,0,0,0,209,132.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.13,329.91V312.77H179.69a49.45,49.45,0,0,0-2.22-8.34l9-5.21-8.57-14.85-9,5.22a50.85,50.85,0,0,0-6.1-6.09l5.22-9-14.85-8.57-5.21,9a49.42,49.42,0,0,0-8.34-2.21V262.26H122.45V272.7a49.45,49.45,0,0,0-8.34,2.22l-5.21-9-14.85,8.57,5.23,9a50.21,50.21,0,0,0-6.1,6.1l-9-5.22-8.57,14.85,9,5.21a49.42,49.42,0,0,0-2.21,8.34H71.94v17.15H82.39a49.42,49.42,0,0,0,2.21,8.34l-9,5.21,8.57,14.85,9-5.23a49.42,49.42,0,0,0,6.09,6.1l-5.21,9,14.84,8.57,5.22-9a48.93,48.93,0,0,0,8.34,2.21v10.44h17.14V370a49.42,49.42,0,0,0,8.34-2.21l5.21,9L168,368.24l-5.22-9.05a49.42,49.42,0,0,0,6.09-6.1l9,5.22,8.57-14.84-9-5.22a48.93,48.93,0,0,0,2.21-8.34ZM131,353.3A31.95,31.95,0,1,1,163,321.35,31.94,31.94,0,0,1,131,353.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.62,381H122.48a.5.5,0,0,1-.5-.5v-10a49.87,49.87,0,0,1-7.62-2l-5,8.66a.53.53,0,0,1-.31.24.52.52,0,0,1-.38-.06l-14.84-8.57a.5.5,0,0,1-.19-.68l5-8.68a50.33,50.33,0,0,1-5.56-5.56l-8.69,5a.5.5,0,0,1-.68-.19l-8.57-14.84a.46.46,0,0,1-.05-.38.52.52,0,0,1,.23-.31l8.66-5a49.74,49.74,0,0,1-2-7.61h-10a.5.5,0,0,1-.5-.5V312.79a.51.51,0,0,1,.5-.5H82a49.74,49.74,0,0,1,2-7.61l-8.66-5a.53.53,0,0,1-.24-.31.56.56,0,0,1,0-.38l8.58-14.85a.5.5,0,0,1,.68-.18l8.68,5a49.57,49.57,0,0,1,5.56-5.57l-5-8.68a.5.5,0,0,1,.18-.68l14.85-8.57a.51.51,0,0,1,.69.18l5,8.66a49.44,49.44,0,0,1,7.61-2v-10a.5.5,0,0,1,.5-.5H139.6a.51.51,0,0,1,.5.5v10a49.74,49.74,0,0,1,7.61,2l5-8.66a.53.53,0,0,1,.31-.24.57.57,0,0,1,.38.05L168.25,274a.5.5,0,0,1,.18.68l-5,8.68A51.3,51.3,0,0,1,169,289l8.68-5a.5.5,0,0,1,.38-.05.47.47,0,0,1,.3.23L186.92,299a.46.46,0,0,1,.05.38.44.44,0,0,1-.23.3l-8.66,5a49.87,49.87,0,0,1,2,7.62h10a.5.5,0,0,1,.5.5v17.14a.5.5,0,0,1-.5.5h-10a49.57,49.57,0,0,1-2,7.62l8.66,5a.5.5,0,0,1,.19.68l-8.58,14.85a.5.5,0,0,1-.68.19l-8.68-5a50.33,50.33,0,0,1-5.56,5.56l5,8.69a.5.5,0,0,1,.05.38.52.52,0,0,1-.23.3l-14.85,8.57a.51.51,0,0,1-.38.05.52.52,0,0,1-.31-.23l-5-8.66a49.74,49.74,0,0,1-7.61,2v10A.5.5,0,0,1,139.62,381ZM123,380h16.14V370a.5.5,0,0,1,.41-.49,49.37,49.37,0,0,0,8.26-2.19.5.5,0,0,1,.6.22l5,8.59,14-8.08-5-8.61a.51.51,0,0,1,.11-.63,49.23,49.23,0,0,0,6-6,.5.5,0,0,1,.63-.11l8.61,5,8.07-14-8.59-5a.5.5,0,0,1-.22-.61,49.26,49.26,0,0,0,2.19-8.25.5.5,0,0,1,.49-.42h9.94V313.27h-9.94a.51.51,0,0,1-.5-.42A49.26,49.26,0,0,0,177,304.6a.5.5,0,0,1,.22-.6l8.59-5-8.07-14-8.61,5a.52.52,0,0,1-.64-.11,48.46,48.46,0,0,0-6-6,.49.49,0,0,1-.12-.63l5-8.61-14-8.07-5,8.59a.5.5,0,0,1-.61.22,49,49,0,0,0-8.25-2.19.49.49,0,0,1-.41-.49v-9.94H123v9.94a.5.5,0,0,1-.41.5,49.12,49.12,0,0,0-8.26,2.19.5.5,0,0,1-.6-.22l-5-8.59-14,8.07,5,8.61a.52.52,0,0,1-.11.64,48.46,48.46,0,0,0-6,6,.48.48,0,0,1-.63.11l-8.61-5-8.07,14,8.59,5a.49.49,0,0,1,.22.6,49.37,49.37,0,0,0-2.19,8.26.49.49,0,0,1-.49.41H72.44v16.15h10a.49.49,0,0,1,.49.41,49.12,49.12,0,0,0,2.19,8.26.49.49,0,0,1-.22.6l-8.59,5,8.08,14,8.61-5a.51.51,0,0,1,.63.11,49.23,49.23,0,0,0,6,6,.5.5,0,0,1,.11.63l-5,8.61,14,8.07,5-8.6a.49.49,0,0,1,.61-.21,49.26,49.26,0,0,0,8.25,2.19.5.5,0,0,1,.42.49ZM131,353.8a32.45,32.45,0,1,1,32.44-32.45A32.48,32.48,0,0,1,131,353.8Zm0-63.89a31.45,31.45,0,1,0,31.44,31.44A31.48,31.48,0,0,0,131,289.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.24,327.46V315.89h-7a33.06,33.06,0,0,0-1.49-5.63l6.09-3.52-5.79-10-6.1,3.52a33.32,33.32,0,0,0-4.12-4.11L610.3,290l-10-5.78-3.52,6.09a33.06,33.06,0,0,0-5.63-1.49v-7H579.56v7a32.84,32.84,0,0,0-5.63,1.5l-3.52-6.09-10,5.78,3.52,6.11a33.24,33.24,0,0,0-4.11,4.11l-6.11-3.52-5.78,10,6.09,3.51a33.33,33.33,0,0,0-1.5,5.63h-7v11.58h7a34,34,0,0,0,1.49,5.63l-6.09,3.51,5.79,10,6.11-3.53a33.32,33.32,0,0,0,4.11,4.12l-3.52,6.1,10,5.79,3.52-6.1a33.08,33.08,0,0,0,5.63,1.5v7.05h11.58v-7.05a33.33,33.33,0,0,0,5.63-1.5l3.51,6.09,10-5.79-3.53-6.1a33.4,33.4,0,0,0,4.12-4.12l6.1,3.52,5.79-10-6.1-3.52a33.08,33.08,0,0,0,1.5-5.63Zm-39.89,15.79a21.57,21.57,0,1,1,21.57-21.57A21.57,21.57,0,0,1,585.35,343.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.15,362.08H579.57a.51.51,0,0,1-.5-.5V355a35.61,35.61,0,0,1-4.9-1.3l-3.31,5.73a.51.51,0,0,1-.69.18l-10-5.79a.44.44,0,0,1-.23-.3.46.46,0,0,1,.05-.38l3.31-5.74a33.71,33.71,0,0,1-3.58-3.59L554,347.08a.46.46,0,0,1-.38.05.5.5,0,0,1-.3-.23l-5.79-10a.5.5,0,0,1-.05-.38.52.52,0,0,1,.23-.3l5.73-3.31a33.89,33.89,0,0,1-1.3-4.9h-6.63a.5.5,0,0,1-.5-.5V315.9a.5.5,0,0,1,.5-.5h6.63a32.65,32.65,0,0,1,1.3-4.9l-5.73-3.31a.5.5,0,0,1-.19-.68l5.79-10a.5.5,0,0,1,.3-.23.5.5,0,0,1,.38.05l5.74,3.31a34.67,34.67,0,0,1,3.59-3.58L560,290.28a.5.5,0,0,1,.19-.68l10-5.79a.55.55,0,0,1,.38-.05.48.48,0,0,1,.3.24l3.31,5.73a34.26,34.26,0,0,1,4.9-1.31v-6.63a.5.5,0,0,1,.5-.5h11.58a.5.5,0,0,1,.5.5v6.63a34.38,34.38,0,0,1,4.91,1.3l3.3-5.73a.53.53,0,0,1,.31-.24.56.56,0,0,1,.38.05l10,5.79a.54.54,0,0,1,.24.3.5.5,0,0,1-.06.38L607.42,296A34.67,34.67,0,0,1,611,299.6l5.74-3.31a.49.49,0,0,1,.68.18l5.79,10a.49.49,0,0,1-.18.68l-5.73,3.31a33.1,33.1,0,0,1,1.3,4.91h6.63a.5.5,0,0,1,.5.5v11.57a.5.5,0,0,1-.5.5h-6.62a34.4,34.4,0,0,1-1.31,4.91l5.74,3.31a.47.47,0,0,1,.23.3.51.51,0,0,1,0,.38l-5.79,10a.5.5,0,0,1-.68.19L611,343.75a34.76,34.76,0,0,1-3.59,3.59l3.32,5.74a.51.51,0,0,1-.18.69l-10,5.78a.49.49,0,0,1-.68-.18l-3.31-5.73a33,33,0,0,1-4.9,1.3v6.64A.51.51,0,0,1,591.15,362.08Zm-11.08-1h10.58v-6.55a.5.5,0,0,1,.41-.5,32.21,32.21,0,0,0,5.54-1.47.51.51,0,0,1,.61.22l3.26,5.66,9.16-5.29-3.27-5.67a.51.51,0,0,1,.11-.64,32.28,32.28,0,0,0,4-4,.51.51,0,0,1,.64-.11l5.67,3.27,5.28-9.16-5.66-3.27a.5.5,0,0,1-.22-.6,32.47,32.47,0,0,0,1.48-5.54.5.5,0,0,1,.49-.42h6.54V316.39h-6.55a.5.5,0,0,1-.49-.42,32.45,32.45,0,0,0-1.47-5.54.49.49,0,0,1,.22-.6l5.66-3.27-5.29-9.16-5.67,3.27a.49.49,0,0,1-.64-.11,33,33,0,0,0-4-4.05.48.48,0,0,1-.11-.63l3.27-5.67-9.16-5.29-3.27,5.66a.5.5,0,0,1-.6.22,33.26,33.26,0,0,0-5.55-1.47.49.49,0,0,1-.41-.49v-6.55H580.05v6.55a.49.49,0,0,1-.41.49,33.16,33.16,0,0,0-5.54,1.48.51.51,0,0,1-.61-.22l-3.26-5.66-9.16,5.29,3.27,5.67a.49.49,0,0,1-.11.63,33,33,0,0,0-4.05,4.06.51.51,0,0,1-.63.11l-5.67-3.28-5.29,9.16,5.66,3.27a.51.51,0,0,1,.22.61A32.21,32.21,0,0,0,553,316a.49.49,0,0,1-.49.41H546V327h6.55a.49.49,0,0,1,.49.41,33.26,33.26,0,0,0,1.47,5.55.5.5,0,0,1-.21.6l-5.66,3.27,5.28,9.16,5.68-3.28a.5.5,0,0,1,.63.11,33.76,33.76,0,0,0,4,4.06.49.49,0,0,1,.12.63l-3.28,5.67,9.16,5.29,3.27-5.67a.5.5,0,0,1,.6-.22,32.58,32.58,0,0,0,5.55,1.48.49.49,0,0,1,.41.49Zm5.28-17.33a22.07,22.07,0,1,1,22.07-22.07A22.09,22.09,0,0,1,585.35,343.75Zm0-43.13a21.07,21.07,0,1,0,21.07,21.06A21.09,21.09,0,0,0,585.35,300.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.67,163.51V151.94h-7a33.08,33.08,0,0,0-1.5-5.63l6.09-3.52-5.78-10-6.11,3.53a33.4,33.4,0,0,0-4.12-4.12l3.53-6.1-10-5.79-3.52,6.09a33.76,33.76,0,0,0-5.63-1.49v-7H523v7a33.08,33.08,0,0,0-5.63,1.5l-3.52-6.09-10,5.79,3.52,6.1a34,34,0,0,0-4.11,4.12l-6.1-3.53-5.79,10,6.09,3.52a34,34,0,0,0-1.49,5.63h-7.05v11.57h7.05a33.08,33.08,0,0,0,1.5,5.63l-6.09,3.52,5.79,10,6.1-3.52a34,34,0,0,0,4.12,4.11l-3.53,6.1,10,5.79,3.52-6.09a32.82,32.82,0,0,0,5.63,1.49v7h11.57v-7a33.08,33.08,0,0,0,5.63-1.5l3.52,6.09,10-5.78-3.52-6.11a34,34,0,0,0,4.11-4.12l6.1,3.53,5.79-10-6.09-3.52a32.82,32.82,0,0,0,1.49-5.63ZM528.78,179.3a21.57,21.57,0,1,1,21.56-21.56A21.56,21.56,0,0,1,528.78,179.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.57,198.13H523a.5.5,0,0,1-.5-.5V191a34,34,0,0,1-4.91-1.3l-3.31,5.73a.49.49,0,0,1-.68.18l-10-5.78a.56.56,0,0,1-.23-.31.57.57,0,0,1,.05-.38l3.32-5.74a33.71,33.71,0,0,1-3.59-3.58l-5.74,3.31a.47.47,0,0,1-.38.05.48.48,0,0,1-.31-.23l-5.78-10a.51.51,0,0,1-.06-.38.53.53,0,0,1,.24-.31l5.73-3.3a32.78,32.78,0,0,1-1.3-4.91h-6.64a.5.5,0,0,1-.5-.5V152a.5.5,0,0,1,.5-.5h6.63a34,34,0,0,1,1.3-4.91l-5.73-3.31a.49.49,0,0,1-.18-.68l5.78-10a.51.51,0,0,1,.69-.18l5.74,3.32a33.71,33.71,0,0,1,3.58-3.59l-3.31-5.74a.51.51,0,0,1,.18-.69l10-5.78a.47.47,0,0,1,.38-.05.48.48,0,0,1,.31.23l3.31,5.73a32.34,32.34,0,0,1,4.9-1.3v-6.64a.5.5,0,0,1,.5-.5h11.57a.5.5,0,0,1,.5.5v6.63a34,34,0,0,1,4.91,1.3l3.31-5.73a.49.49,0,0,1,.68-.18l10,5.78a.56.56,0,0,1,.23.31.51.51,0,0,1-.05.38l-3.32,5.74a32.8,32.8,0,0,1,3.59,3.58l5.75-3.31a.5.5,0,0,1,.68.18l5.79,10a.52.52,0,0,1-.19.69l-5.73,3.31a34.26,34.26,0,0,1,1.31,4.9h6.63a.5.5,0,0,1,.5.5v11.58a.51.51,0,0,1-.5.5H562a34.24,34.24,0,0,1-1.3,4.9l5.73,3.31a.49.49,0,0,1,.18.68l-5.78,10a.52.52,0,0,1-.31.23.51.51,0,0,1-.38,0l-5.74-3.31a34.57,34.57,0,0,1-3.58,3.58l3.31,5.75a.46.46,0,0,1,.05.38.49.49,0,0,1-.23.3l-10,5.79a.56.56,0,0,1-.38,0,.53.53,0,0,1-.31-.24l-3.3-5.73a34.4,34.4,0,0,1-4.91,1.31v6.63A.5.5,0,0,1,534.57,198.13Zm-11.07-1h10.57v-6.55a.5.5,0,0,1,.42-.49,33.42,33.42,0,0,0,5.54-1.48.5.5,0,0,1,.6.22l3.27,5.66,9.16-5.29-3.28-5.67a.5.5,0,0,1,.11-.63,33.13,33.13,0,0,0,4.06-4.06.5.5,0,0,1,.63-.11l5.67,3.27,5.29-9.15-5.66-3.27a.5.5,0,0,1-.22-.61,32.45,32.45,0,0,0,1.47-5.54.49.49,0,0,1,.49-.41h6.55V152.44h-6.55a.49.49,0,0,1-.49-.41,32.58,32.58,0,0,0-1.48-5.55.5.5,0,0,1,.22-.6l5.66-3.27-5.29-9.16-5.67,3.28a.5.5,0,0,1-.63-.11,33.13,33.13,0,0,0-4.06-4.06.5.5,0,0,1-.11-.63l3.27-5.67L543.88,121l-3.26,5.66a.5.5,0,0,1-.61.22,33.4,33.4,0,0,0-5.54-1.47.5.5,0,0,1-.42-.49v-6.55H523.48v6.55a.51.51,0,0,1-.41.5,32.32,32.32,0,0,0-5.55,1.47.5.5,0,0,1-.6-.22L513.65,121l-9.16,5.29,3.28,5.67a.5.5,0,0,1-.11.63,33.13,33.13,0,0,0-4.06,4.06.49.49,0,0,1-.63.11l-5.67-3.27L492,142.63l5.66,3.26a.5.5,0,0,1,.22.61,33.14,33.14,0,0,0-1.47,5.54.5.5,0,0,1-.49.42h-6.55V163h6.55a.5.5,0,0,1,.49.42A33.42,33.42,0,0,0,497.9,169a.5.5,0,0,1-.22.6L492,172.86l5.29,9.16,5.67-3.28a.5.5,0,0,1,.63.11,33.13,33.13,0,0,0,4.06,4.06.5.5,0,0,1,.11.63l-3.27,5.67,9.16,5.29,3.26-5.66a.5.5,0,0,1,.61-.22,33.4,33.4,0,0,0,5.54,1.47.5.5,0,0,1,.42.49Zm5.28-17.33a22.07,22.07,0,1,1,22.06-22.06A22.09,22.09,0,0,1,528.78,179.8Zm0-43.13a21.07,21.07,0,1,0,21.06,21.07A21.09,21.09,0,0,0,528.78,136.67Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--number-2--inject-82"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M598.38,390.42V310.24H494V258.9L583.53,46.79h76.36V260.18H693v50.06H659.89v80.18ZM545.77,260.18h52.61V114.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.89,390.92H598.38a.5.5,0,0,1-.5-.5V310.74H494a.5.5,0,0,1-.5-.5V258.9a.43.43,0,0,1,0-.19L583.07,46.59a.51.51,0,0,1,.46-.3h76.36a.5.5,0,0,1,.5.5V259.68H693a.5.5,0,0,1,.5.5v50.06a.5.5,0,0,1-.5.5H660.39v79.68A.5.5,0,0,1,659.89,390.92Zm-61-1h60.51V310.24a.5.5,0,0,1,.5-.5h32.59V260.68H659.89a.51.51,0,0,1-.5-.5V47.29H583.86L494.52,259v50.74H598.38a.5.5,0,0,1,.5.5Zm-.5-129.24H545.77a.5.5,0,0,1-.41-.22.51.51,0,0,1-.06-.45l52.61-145.94a.49.49,0,0,1,.55-.32.5.5,0,0,1,.42.49V260.18A.51.51,0,0,1,598.38,260.68Zm-51.89-1h51.39V117.1Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--number-1--inject-82"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.54,390.42V310.24H45.18V258.9L134.69,46.79h76.37V260.18h33.09v50.06H211.06v80.18ZM96.94,260.18h52.6V114.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.06,390.92H149.54a.51.51,0,0,1-.5-.5V310.74H45.18a.51.51,0,0,1-.5-.5V258.9a.65.65,0,0,1,0-.19L134.23,46.59a.51.51,0,0,1,.46-.3h76.37a.5.5,0,0,1,.5.5V259.68h32.59a.5.5,0,0,1,.5.5v50.06a.51.51,0,0,1-.5.5H211.56v79.68A.51.51,0,0,1,211.06,390.92Zm-61-1h60.52V310.24a.5.5,0,0,1,.5-.5h32.59V260.68H211.06a.5.5,0,0,1-.5-.5V47.29H135L45.68,259v50.74H149.54a.5.5,0,0,1,.5.5Zm-.5-129.24H96.94a.49.49,0,0,1-.41-.22.48.48,0,0,1-.06-.45l52.6-145.94a.51.51,0,0,1,.56-.32.49.49,0,0,1,.41.49V260.18A.5.5,0,0,1,149.54,260.68Zm-51.89-1H149V117.1Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-82"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M367.17,396.35q-31,0-51.33-12.72a79.1,79.1,0,0,1-30.54-35q-10.19-22.28-10.19-51.55v-154q0-30.12,9.76-52.82A76.2,76.2,0,0,1,315,54.85q20.37-12.74,52.18-12.73,31.4,0,51.55,12.73a76.64,76.64,0,0,1,29.91,35.42q9.75,22.7,9.75,52.82v154q0,29.28-10.18,51.55a79.16,79.16,0,0,1-30.54,35Q397.29,396.35,367.17,396.35Zm0-57.69q11.46,0,16.55-7.21a41.61,41.61,0,0,0,6.79-17.18,111.72,111.72,0,0,0,1.69-18.46V144.36a135.16,135.16,0,0,0-1.48-19.51,41.22,41.22,0,0,0-6.58-17.61q-5.08-7.41-17-7.42T350,107.24a39.58,39.58,0,0,0-6.79,17.61,135.16,135.16,0,0,0-1.48,19.51V295.81a109.67,109.67,0,0,0,1.7,18.46,38.25,38.25,0,0,0,7.21,17.18Q356.14,338.67,367.17,338.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.17,396.85c-20.64,0-38-4.3-51.59-12.8a80,80,0,0,1-30.74-35.21c-6.78-14.85-10.23-32.26-10.23-51.76v-154c0-20.06,3.3-37.9,9.8-53a77.07,77.07,0,0,1,30.32-35.65c13.59-8.49,31.24-12.8,52.44-12.8,20.93,0,38.36,4.31,51.81,12.81a77.36,77.36,0,0,1,30.1,35.64c6.51,15.13,9.8,33,9.8,53v154c0,19.5-3.44,36.91-10.22,51.76a80,80,0,0,1-30.74,35.21C404.33,392.55,387.25,396.85,367.17,396.85Zm0-354.23c-21,0-38.48,4.26-51.91,12.65a76,76,0,0,0-29.93,35.2c-6.45,15-9.72,32.69-9.72,52.62v154c0,19.36,3.41,36.63,10.14,51.34a79,79,0,0,0,30.36,34.78c13.43,8.4,30.61,12.65,51.06,12.65,19.9,0,36.79-4.25,50.22-12.65a79,79,0,0,0,30.36-34.78c6.72-14.71,10.13-32,10.13-51.34v-154c0-19.91-3.27-37.62-9.71-52.62a76.46,76.46,0,0,0-29.72-35.2C405.16,46.88,387.91,42.62,367.17,42.62Zm0,296.54c-7.49,0-13.19-2.49-16.94-7.41a39.07,39.07,0,0,1-7.31-17.4,111.25,111.25,0,0,1-1.7-18.54V144.36a135.66,135.66,0,0,1,1.49-19.59A40.16,40.16,0,0,1,349.59,107c3.61-5.06,9.53-7.63,17.58-7.63s13.9,2.57,17.38,7.64a41.85,41.85,0,0,1,6.66,17.81,136.72,136.72,0,0,1,1.49,19.59V295.81a112,112,0,0,1-1.7,18.54,42.17,42.17,0,0,1-6.87,17.39C380.65,336.66,375,339.16,367.17,339.16Zm0-238.84c-7.71,0-13.35,2.42-16.77,7.21a39.16,39.16,0,0,0-6.7,17.39,135,135,0,0,0-1.48,19.44V295.81a110.31,110.31,0,0,0,1.69,18.37,38,38,0,0,0,7.11,17c3.56,4.66,9,7,16.15,7,7.44,0,12.86-2.36,16.14-7a41,41,0,0,0,6.7-17,111.07,111.07,0,0,0,1.69-18.37V144.36a136,136,0,0,0-1.48-19.44,40.94,40.94,0,0,0-6.49-17.4C380.45,102.74,374.88,100.32,367.17,100.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.15,218.79l3.72,53.51-23.2-10.83L249.79,285s49.8,27.83,54.75,26.91-7.42-109.19-7.42-109.19Z",
    style: {
      fill: "#0D6EFD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.32,312.4c-6.3,0-49.75-24.18-54.77-27a.48.48,0,0,1-.24-.55l5.87-23.51a.5.5,0,0,1,.7-.33l22.43,10.46-3.65-52.66a.48.48,0,0,1,.2-.44l22-16.08a.5.5,0,0,1,.5-.06.52.52,0,0,1,.29.41c0,.27,3.12,27.38,5.57,54.25,5,54.81,2.51,55.28,1.45,55.48Zm-53.95-27.67c20,11.15,50.63,27.31,54.08,26.66,3.05-2.21-3.08-66.91-7.73-107.78L275.67,219l3.7,53.23a.5.5,0,0,1-.22.45.52.52,0,0,1-.5,0L256,262.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.59,347.87s26.71-9.18,37.15-17.94-44.25-114.79-44.25-114.79S302.33,312.4,308.59,347.87Z",
    style: {
      fill: "#0D6EFD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.59,348.38a.59.59,0,0,1-.26-.07.5.5,0,0,1-.23-.35c-6.2-35.11-7.1-131.84-7.11-132.81a.5.5,0,0,1,.38-.49.5.5,0,0,1,.57.26c2.24,4.34,54.74,106.47,44.12,115.39-10.39,8.72-37,17.95-37.31,18A.45.45,0,0,1,308.59,348.38ZM302,217.25c.16,14.34,1.38,97.4,7,130,3.88-1.37,27-9.75,36.43-17.67C353.55,322.71,317.73,247.94,302,217.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.41,313.62l-3.09.46a3,3,0,0,1,0,.46c-.24,4-21.7,14.54-36.86,20.26-3.31,2.56-7.75,3.86-13.33,3.86H367c-11.69,1.13-34.17-4-39.25-7.5l-5.48,56h0c.88.44,1.78.85,2.69,1.26q17.81,7.89,42.18,7.9,28.14,0,47.76-11.1l.28-.16c.83-.48,1.64-1,2.45-1.46s1.91-1.23,2.84-1.87l.85-.59,1.94-1.4.9-.69c.64-.49,1.27-1,1.88-1.49l.76-.62c.85-.71,1.69-1.43,2.5-2.18h0C425.84,350,420.41,313.62,420.41,313.62Z",
    style: {
      fill: "#737373"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.17,396.85c-16.23,0-30.49-2.67-42.39-7.94q-1.36-.62-2.7-1.26a.51.51,0,0,1-.23-.23.45.45,0,0,1-.05-.28l5.48-56a.49.49,0,0,1,.28-.41.5.5,0,0,1,.49,0c5,3.4,27.35,8.54,38.93,7.42h.16c5.46,0,9.84-1.27,13.05-3.76l.13-.07c16.39-6.18,36.34-16.4,36.54-19.82a3,3,0,0,0,0-.36.5.5,0,0,1,.42-.56l3.09-.46a.51.51,0,0,1,.57.42c0,.36,5.47,36.66,8.92,61.17a.49.49,0,0,1-.09.37l-.1.09c-.72.67-1.55,1.38-2.49,2.17l-.76.62c-.62.51-1.25,1-1.89,1.51l-.91.69c-.64.47-1.29.94-1.95,1.4l-.28.2-.57.4c-1.05.71-2,1.33-2.87,1.88s-1.63,1-2.46,1.47l-.28.16C402.07,393.1,385.93,396.85,367.17,396.85Zm-44.35-10c.78.37,1.57.74,2.37,1.09,11.77,5.22,25.89,7.86,42,7.86,18.58,0,34.56-3.71,47.51-11l.28-.16c.82-.47,1.63-.95,2.43-1.45s1.8-1.15,2.83-1.85l.56-.39.28-.2c.65-.46,1.3-.92,1.93-1.4l.9-.67c.63-.49,1.25-1,1.87-1.49l.75-.61c.85-.72,1.6-1.37,2.29-2-3.23-22.93-8.15-56-8.81-60.4l-2.13.32v.06c-.28,4.75-24.67,16-37.11,20.67-3.4,2.6-8,3.92-13.58,3.92h-.1c-11.64,1.11-32.68-3.69-38.88-7.16Zm-.53.29h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.65,248.55S325.39,309,325.7,311.18s-2.45,15.89,1.53,19.55,30.55,9.78,41.85,7.64,48-18.64,48.28-23.83S381,207.91,376.42,195.69s-23.22-16.5-35.75-15.28-42.77,9.17-48.27,16.81S300.65,248.55,300.65,248.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.32,339.32c-12.89,0-32.83-4.89-36.43-8.22-3.14-2.9-2.36-11.37-1.89-16.43a23.59,23.59,0,0,0,.2-3.42c-.27-1.78-18.15-45.73-25-62.51,0,0,0,0,0,0-.57-1.8-13.76-44-8.18-51.77,5.81-8.08,37-15.88,48.63-17,12.18-1.19,31.49,2.86,36.26,15.59,3.94,10.49,41.3,113.61,41,119.06-.34,5.79-37.81,22.23-48.68,24.29A32,32,0,0,1,363.32,339.32Zm-62.2-90.94c2.57,6.29,24.77,60.59,25.07,62.73a22.23,22.23,0,0,1-.19,3.65c-.43,4.56-1.21,13,1.57,15.61,4,3.69,30.44,9.59,41.42,7.51,12.39-2.34,47.6-18.81,47.87-23.37.29-4.91-35.76-104.9-40.91-118.64-4.59-12.24-23.37-16.12-35.23-15-12.9,1.26-42.68,9.32-47.92,16.6S300.76,247.25,301.12,248.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.78,192.33s-3,27.8-1.22,33.61,10.17,21.77,10.17,21.77,14-17.5,16.72-19.33,28.11,14.36,28.11,14.36.91-17.41-2.75-31.77-10.09-29.95-12.22-32.7-2.14,7.34-10.09,14.06S302.78,192.33,302.78,192.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.73,248.21h0a.52.52,0,0,1-.4-.27c-.34-.65-8.38-16.07-10.2-21.85s1.07-32.68,1.2-33.82a.48.48,0,0,1,.22-.36.55.55,0,0,1,.43-.06c.2.07,20.6,6.56,28.24.1,4.34-3.67,6.24-8.32,7.49-11.39.82-2,1.28-3.12,2.12-3.24A1.39,1.39,0,0,1,342,178c2.3,3,8.74,18.87,12.31,32.87,3.64,14.27,2.78,31.75,2.77,31.93a.53.53,0,0,1-.27.42.5.5,0,0,1-.5,0c-12.33-7.87-26-15.39-27.56-14.36C326.6,230.21,316.94,242,312.12,248A.48.48,0,0,1,311.73,248.21ZM303.22,193c-.43,4.08-2.81,27.63-1.18,32.8,1.58,5,8.18,17.9,9.78,21,2.52-3.14,13.83-17.15,16.35-18.83,2.74-1.83,22.35,10.35,27.92,13.88.12-3.68.38-18.44-2.77-30.76-3.77-14.79-10.13-29.93-12.13-32.51-.19-.24-.29-.27-.29-.27a9.45,9.45,0,0,0-1.3,2.63c-1.22,3-3.25,7.94-7.77,11.77C324.43,199,306.73,194.05,303.22,193Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.53,197.17a108.27,108.27,0,0,0,11.54,20.45,100.65,100.65,0,0,0,18.8,19.46s8.58-22.1,10.89-35.29-1.65-26.39-1.65-26.39-1.65,19.79-8.58,23.75S300.53,197.17,300.53,197.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.87,237.58a.54.54,0,0,1-.3-.1,101.93,101.93,0,0,1-18.91-19.57,109.91,109.91,0,0,1-11.6-20.56.5.5,0,0,1,.59-.66c.24.05,24,5.84,30.63,2s8.31-23.16,8.33-23.36a.49.49,0,0,1,.44-.45.5.5,0,0,1,.54.35c0,.13,4,13.46,1.66,26.61S331.42,237,331.34,237.26a.49.49,0,0,1-.33.3Zm-29.5-39.7a113.69,113.69,0,0,0,11.11,19.45,100.13,100.13,0,0,0,18.17,18.94c1.4-3.7,8.56-22.81,10.61-34.57,1.66-9.44,0-19-1-23.48-.74,5.66-3,18.2-8.52,21.36C325.48,203.19,306,199,301.37,197.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.64,200.26a140.56,140.56,0,0,1-18.11-3.09,108.27,108.27,0,0,0,11.54,20.45c.77,1.08,1.56,2.12,2.37,3.15L328.08,205Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.44,221.27h0a.54.54,0,0,1-.38-.19c-.94-1.19-1.7-2.2-2.39-3.17a109.91,109.91,0,0,1-11.6-20.56.5.5,0,0,1,.59-.66,140.63,140.63,0,0,0,18,3.07.48.48,0,0,1,.18.05l9.45,4.72a.51.51,0,0,1,.15.78l-13.64,15.78A.53.53,0,0,1,314.44,221.27Zm-13.07-23.39a113,113,0,0,0,11.11,19.45c.58.83,1.22,1.68,2,2.65l12.82-14.84-8.78-4.39A138.54,138.54,0,0,1,301.37,197.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.11,175.4s10,40.15,13.7,70.4,12.52,119.76,12.52,119.76,27.5-7.94,41.86-18.33,18.94-17.41,18.94-17.41-23.52-103-23.52-104.49,2.44-16.81,2.44-16.81S447.6,189,463.49,177.05s11.92-18.33,4.28-21.38-31.47.3-44.61,4-19.86,6.11-19.86,6.11-14.66-1.22-28.11,1.83S340.11,175.4,340.11,175.4Z",
    style: {
      fill: "#0D6EFD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.33,366.06a.57.57,0,0,1-.28-.08.51.51,0,0,1-.21-.37c-.09-.89-8.91-89.86-12.53-119.75s-13.59-69.94-13.69-70.34a.51.51,0,0,1,.38-.61c.22,0,21.8-4.8,35.08-7.82,12.76-2.89,26.77-2,28.15-1.85.9-.32,7.66-2.7,19.8-6.08,13.16-3.68,37.21-7,44.92-4,4.17,1.67,6.57,4.06,6.95,6.93.56,4.22-3.18,9.38-11.11,15.32-15.12,11.34-53.86,29.79-57.29,31.41-.85,5.34-2.39,15.31-2.39,16.47.13,1.74,15.44,69,23.51,104.38a.47.47,0,0,1-.07.38c-.19.29-4.79,7.22-19.07,17.55s-41.73,18.32-42,18.4A.32.32,0,0,1,366.33,366.06ZM340.71,175.78c1.17,4.72,10.19,41.84,13.59,70C357.77,274.35,366,357,366.77,364.91c4-1.21,28.15-8.69,41.13-18.08s17.89-16,18.7-17.12c-2.64-11.52-23.49-102.85-23.49-104.38s2.35-16.26,2.45-16.89a.48.48,0,0,1,.28-.37c.41-.2,41.69-19.67,57.35-31.42,7.62-5.71,11.22-10.55,10.72-14.39-.34-2.52-2.46-4.58-6.33-6.13-7.52-3-31.25.35-44.28,4s-19.76,6.07-19.83,6.1a.71.71,0,0,1-.21,0c-.14,0-14.75-1.18-28,1.82C363.14,170.83,344,175.05,340.71,175.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.21,278.12l-1.6,4.95",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.61,283.57l-.15,0a.49.49,0,0,1-.32-.63c.58-1.79,1.11-3.43,1.59-4.95a.5.5,0,0,1,1,.3c-.49,1.53-1,3.16-1.6,5A.5.5,0,0,1,359.61,283.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.48,274.52l-.14,0a.5.5,0,0,1-.33-.62,123.76,123.76,0,0,0,4.44-21.12c2-14.28,3.46-36.57,3.64-39.39l-4.44-2.83a.5.5,0,1,1,.54-.84l4.69,3a.52.52,0,0,1,.23.46c0,.24-1.57,24.53-3.67,39.75A123.69,123.69,0,0,1,363,274.17.5.5,0,0,1,362.48,274.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.39,209a.47.47,0,0,1-.27-.08l-2.86-1.82a.5.5,0,0,1-.17-.66c1.82-3.39,4.52-8.9,4.52-10.15,0-.3-.54-2.27-7.43-14.93a.5.5,0,1,1,.88-.48c7.55,13.88,7.55,15,7.55,15.41,0,1.73-3.44,8.35-4.42,10.22l2.47,1.57a.5.5,0,0,1,.15.69A.48.48,0,0,1,363.39,209Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.72,175.86l1.25,2.25",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356,178.61a.5.5,0,0,1-.44-.25c-.76-1.39-1.25-2.26-1.25-2.26a.51.51,0,0,1,.19-.68.5.5,0,0,1,.68.2s.49.87,1.25,2.25a.49.49,0,0,1-.19.68A.53.53,0,0,1,356,178.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.69,332.76a.5.5,0,0,1-.48-.36l-2.14-7.33a.5.5,0,0,1,.31-.61s2.45-.92,16.8-6.41a73.93,73.93,0,0,0,15.51-8,.5.5,0,1,1,.57.82A76,76,0,0,1,395.54,319c-11.28,4.32-15.21,5.81-16.38,6.25l1.89,6.45c3.39-.69,25.41-5.57,35.93-17.47a.5.5,0,0,1,.71,0,.5.5,0,0,1,0,.7c-11.59,13.12-36.69,17.84-37,17.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.13,306.29a23.21,23.21,0,0,1-2.05,1.83",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.08,308.62a.48.48,0,0,1-.38-.18.5.5,0,0,1,.07-.71,23.92,23.92,0,0,0,2-1.78.5.5,0,0,1,.73.69,27.3,27.3,0,0,1-2.1,1.87A.54.54,0,0,1,414.08,308.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.05,209a.44.44,0,0,1-.22-.05.5.5,0,0,1-.25-.61l5.48-16.22a.5.5,0,1,1,.94.32l-4.26,12.63L418.47,189a.49.49,0,0,1,.69-.14.5.5,0,0,1,.14.69L406.47,208.8A.52.52,0,0,1,406.05,209Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 414,
    y1: 185,
    x2: 412.73,
    y2: 188.75,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.73,189.25a.45.45,0,0,1-.16,0,.5.5,0,0,1-.31-.63l1.26-3.75a.5.5,0,1,1,1,.32l-1.27,3.75A.51.51,0,0,1,412.73,189.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.78,192.33s3.06,55.61,6.42,82.8,8.86,94.41,8.86,94.41-10.69-.92-17.72-9.48a97.86,97.86,0,0,1-10.39-15V284.6c0-2.45-4.89-30.25-9.47-44s-11.3-29.63-7.33-36.36,16.5-16.8,21.08-18S302.48,186.22,302.78,192.33Z",
    style: {
      fill: "#0D6EFD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.06,370h0c-.45,0-11-1-18.07-9.65a99.19,99.19,0,0,1-10.44-15.05.53.53,0,0,1-.06-.24V284.6c0-2.56-5-30.41-9.44-43.84-.72-2.15-1.49-4.35-2.26-6.57-4.18-12-8.5-24.33-5-30.2,4-6.76,16.53-17,21.38-18.25,2.82-.76,5-.55,6.64.6s2.4,3.13,2.54,6h0c0,.56,3.1,55.9,6.42,82.77s8.8,93.75,8.86,94.42a.49.49,0,0,1-.15.4A.51.51,0,0,1,318.06,370ZM290.45,345a100.28,100.28,0,0,0,10.28,14.78c5.87,7.14,14.47,8.87,16.78,9.21-.56-6.83-5.66-68.28-8.81-93.77-3.32-26.9-6.38-82.28-6.42-82.83h0c-.12-2.51-.84-4.26-2.13-5.2s-3.28-1.12-5.79-.45c-4.24,1.13-16.74,11-20.78,17.8-3.23,5.47,1,17.62,5.11,29.36.77,2.22,1.55,4.43,2.26,6.58,4.51,13.51,9.5,41.57,9.5,44.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.07,262.17c1.73,5.39,3.4,10.19,4.77,13.26",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.84,275.93a.51.51,0,0,1-.46-.29c-1.25-2.82-2.86-7.31-4.79-13.32a.51.51,0,0,1,.33-.63.49.49,0,0,1,.62.32c1.92,6,3.52,10.43,4.76,13.22a.51.51,0,0,1-.26.66A.45.45,0,0,1,305.84,275.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.89,258.91a.5.5,0,0,1-.48-.35c-4-12.94-8.1-28.26-8.72-31-.85-3.69,3.75-10,5-11.66-1.15-1-4.74-4.17-5.78-5.21-.28-.28-.7-.71.23-7.86a.5.5,0,0,1,.56-.43.51.51,0,0,1,.43.56c-.77,5.89-.55,6.9-.47,7.07,1.16,1.15,6,5.39,6.05,5.43a.5.5,0,0,1,.06.69c-.06.07-5.95,7.49-5.1,11.18.63,2.71,4.71,18,8.71,30.92a.5.5,0,0,1-.33.62A.39.39,0,0,1,299.89,258.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.92,182.55s-1.61,8.76-2.75,16.45",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.17,199.5h-.07a.51.51,0,0,1-.42-.57c1.13-7.61,2.74-16.38,2.75-16.47a.5.5,0,0,1,.58-.4.51.51,0,0,1,.41.58c0,.09-1.63,8.84-2.75,16.44A.51.51,0,0,1,291.17,199.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 297.49,
    y1: 323.8,
    x2: 292.09,
    y2: 321.26,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.49,324.3a.54.54,0,0,1-.21-.05l-5.4-2.54a.5.5,0,0,1,.42-.9l5.41,2.54a.5.5,0,0,1,.24.66A.52.52,0,0,1,297.49,324.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.06,328.79a.54.54,0,0,1-.21-.05L300,325.53a.5.5,0,0,1-.24-.67.49.49,0,0,1,.66-.24l6.14,2.88v-8l-14.66-6a.5.5,0,0,1,.38-.93l15,6.11a.5.5,0,0,1,.31.46v9.17a.5.5,0,0,1-.23.42A.53.53,0,0,1,307.06,328.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280,155.57l5.22,12.79s-6.79-7.05-8.36-.78,3.14,13.58,6.27,13.58,6.79.26,6.79.26,11,19.32,17.75,23,15.93,6.79,21.68,3.65,8.88-11.75,10.7-18.28.53-26.11.53-26.11L331.14,125s6.52-2.35,6.52-6.79-15.14-5.74-15.14-5.74,6-7-1.57-8.1-32.12,13.58-32.9,14.1,4.18-9.14-2.09-5.74-13.58,20.1-12.79,24S280,155.57,280,155.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.65,209.84c-6.14,0-13-3.25-16.25-5-6.51-3.51-16.49-20.62-17.82-22.94-.9-.06-3.89-.24-6.49-.24-1.24,0-2.7-1-4-2.62-2.13-2.73-3.81-7.37-2.75-11.58.4-1.61,1.18-2.58,2.3-2.88,1.71-.45,3.83.84,5.26,2l-4.41-10.79h0c-.24-.61-6-15-6.81-18.89s6.4-21,13-24.56c1.6-.87,2.7-1,3.37-.45,1.1.91.48,3.16-.32,5.57l0,.06C293.48,114.7,314,102.92,321,103.9c2.18.3,3.54,1.12,4.05,2.44.76,2-.74,4.51-1.61,5.73,3.52.38,14.7,1.91,14.7,6.16,0,4.1-4.93,6.47-6.44,7.09l9.3,38.22c.07.89,1.3,19.83-.53,26.37-2.8,10-6.38,16.09-10.94,18.58A12.26,12.26,0,0,1,323.65,209.84ZM279.4,165.48a1.68,1.68,0,0,0-.5.07c-.75.2-1.28.92-1.59,2.15-1,3.89.59,8.19,2.57,10.72,1.09,1.4,2.29,2.24,3.21,2.24,3.12,0,6.79.26,6.83.26a.5.5,0,0,1,.39.25c.11.19,11,19.24,17.56,22.79,4.22,2.27,14.74,7.18,21.2,3.65,4.31-2.35,7.73-8.23,10.46-18,1.79-6.37.52-25.75.51-25.94l-9.39-38.56a.5.5,0,0,1,.32-.59c.06,0,6.19-2.29,6.19-6.32,0-2.9-9-4.76-14.68-5.25a.5.5,0,0,1-.34-.82c.78-.92,2.67-3.7,2-5.47-.36-1-1.45-1.56-3.25-1.8-7.12-1-30.69,12.77-32.55,14a.63.63,0,0,1-.65,0c-.36-.27-.25-.59.14-1.78s1.3-3.94.63-4.5c-.11-.09-.6-.33-2.25.57-6.1,3.3-13.24,20-12.54,23.48.76,3.83,6.7,18.56,6.76,18.71l5.22,12.79a.5.5,0,0,1-.82.54C283.89,167.75,281.28,165.48,279.4,165.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.52,112.49s6-7-1.57-8.1-32.12,13.58-32.9,14.1,4.18-9.14-2.09-5.74-13.58,20.1-12.79,24,6.79,18.8,6.79,18.8l5.22,12.79s6,5.49,3.92,1.31-6.27-13.58-5.23-14.88,6.27-3.4,6.53-6.27-5-11.23-3.39-13.32,23.76,1.83,27.68-.52-1.05-8.09-1.05-8.09l17.5-1.57s6.52-2.35,6.52-6.79S322.52,112.49,322.52,112.49Z",
    style: {
      fill: "#737373"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.31,171.74c-.54,0-1.71-.49-4.47-3a.44.44,0,0,1-.12-.18l-5.23-12.79c-.24-.61-6-15-6.81-18.89s6.4-21,13-24.56c1.6-.87,2.7-1,3.37-.45,1.1.91.48,3.16-.32,5.57l0,.06C293.48,114.7,314,102.92,321,103.9c2.18.3,3.54,1.12,4.05,2.44.76,2-.74,4.51-1.61,5.73,3.52.38,14.7,1.91,14.7,6.16,0,4.74-6.58,7.16-6.86,7.26l-.12,0L314.6,127c.87,1.2,2.38,3.61,2,5.7a3.34,3.34,0,0,1-1.7,2.41c-2.18,1.31-9.12.83-15.83.37-4.69-.32-11.12-.76-11.7,0-.72,1,.62,4.28,1.7,6.95,1,2.44,1.91,4.75,1.79,6.11-.2,2.18-2.71,3.81-4.73,5.12a10.35,10.35,0,0,0-1.91,1.42c-.57.83,1.94,7.67,5.28,14.35.44.86.76,1.72.2,2.14A.63.63,0,0,1,289.31,171.74Zm-3.71-3.67a20.43,20.43,0,0,0,3.37,2.57,5.94,5.94,0,0,0-.32-.75c-.28-.55-6.71-13.48-5.17-15.42a10.38,10.38,0,0,1,2.15-1.63c1.74-1.12,4.12-2.67,4.27-4.37.11-1.12-.82-3.42-1.72-5.65-1.35-3.35-2.63-6.51-1.57-7.92.87-1.16,5.12-.92,12.57-.42,6.25.43,13.34.92,15.25-.23a2.36,2.36,0,0,0,1.23-1.71c.38-2.38-2.37-5.6-2.4-5.63a.5.5,0,0,1-.08-.51.48.48,0,0,1,.42-.31L331,124.53c.63-.24,6.14-2.48,6.14-6.3,0-2.9-9-4.76-14.68-5.25a.5.5,0,0,1-.34-.82c.78-.92,2.67-3.7,2-5.47-.36-1-1.45-1.56-3.25-1.8-7.12-1-30.69,12.77-32.55,14a.63.63,0,0,1-.65,0c-.36-.27-.25-.59.14-1.78s1.3-3.94.63-4.5c-.11-.09-.6-.33-2.25.57-6.1,3.3-13.24,20-12.54,23.48.76,3.83,6.7,18.56,6.76,18.71Zm45.54-43h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.91,177s-2.35,4.44-6,4.7",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.91,182.18a.5.5,0,0,1,0-1c3.33-.24,5.58-4.39,5.6-4.43a.5.5,0,1,1,.88.46c-.1.2-2.52,4.69-6.41,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.72,165c.73,1.57.42,3.26-.69,3.78s-2.6-.34-3.33-1.91-.42-3.26.69-3.78S309,163.4,309.72,165Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 328.34,
    cy: 161.2,
    rx: 2.22,
    ry: 3.13,
    transform: "translate(-21.27 53.64) rotate(-9.05)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.91,191.6a14.29,14.29,0,0,0,7.57-2.35",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.91,192.1a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5,13.88,13.88,0,0,0,7.27-2.25.51.51,0,0,1,.7.1.5.5,0,0,1-.1.7A14.67,14.67,0,0,1,319.91,192.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.67,162.57a1,1,0,0,1-.58-.18,1,1,0,0,1-.24-1.39c.17-.24,4.2-5.79,14.7-2.47a1,1,0,0,1-.61,1.91c-9-2.85-12.32,1.53-12.46,1.71A1,1,0,0,1,296.67,162.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323,157.61a.92.92,0,0,1-.29,0,1,1,0,0,1-.67-1.25,10.88,10.88,0,0,1,9.76-7.23,1,1,0,1,1,.15,2,8.88,8.88,0,0,0-8,5.83A1,1,0,0,1,323,157.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.66,151.39s1.83-4.18,3.92-1.57,2.87,7.84,1.57,11.23-2.09,6.27-2.09,6.27l-.52-3.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.06,167.82h0a.52.52,0,0,1-.47-.43l-.52-3.66-2.86-12.23a.42.42,0,0,1,0-.31c.11-.25,1.13-2.5,2.71-2.71a2.25,2.25,0,0,1,2.05,1c2.25,2.82,3,8.18,1.64,11.72-1.28,3.33-2.06,6.19-2.07,6.22A.5.5,0,0,1,341.06,167.82Zm-2.87-16.37,2.83,12.1.21,1.46c.36-1.12.85-2.58,1.45-4.14,1.23-3.19.53-8.21-1.49-10.73-.39-.49-.78-.72-1.14-.67C339.25,149.58,338.48,150.84,338.19,151.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.71,131S357,125.8,355.16,125.8s-23.24,3.92-26.37,5.22-26.9,8.1-26.38,9.67,3.4,2.08,3.4,2.08.52,2.35,8.88,3.4,27.93-1.57,28.2.26a4.55,4.55,0,0,1-1.31,3.39l2.35,4.18s8.62-1.3,11.49-3.39,11-8.62,11-8.62l17.49,1.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.93,154.5a.5.5,0,0,1-.44-.25l-2.35-4.18a.5.5,0,0,1,.09-.6,4.18,4.18,0,0,0,1.17-2.89c-.84-.56-6.8-.26-11.6,0-5.72.28-12.2.6-16.18.1-7-.87-8.72-2.68-9.16-3.45-.8-.18-3-.81-3.52-2.37a.67.67,0,0,1,.05-.54c.63-1.24,6.79-3.37,19.52-7.4,3.31-1.05,6.17-2,7.08-2.34,3.12-1.3,24.64-5.26,26.57-5.26s29.46,5,30.64,5.23a.5.5,0,0,1,.4.57l-1.83,12.27a.49.49,0,0,1-.53.42l-17.29-1.29c-1.14.92-8.21,6.6-10.84,8.51-2.93,2.14-11.35,3.43-11.71,3.49Zm-1.74-4.61,2,3.56c1.62-.26,8.51-1.48,10.93-3.25,2.83-2,10.87-8.53,10.95-8.6a.51.51,0,0,1,.35-.11l17,1.27,1.69-11.33c-10-1.82-28.59-5.13-30-5.13-1.9,0-23.11,3.91-26.18,5.19-1,.39-3.7,1.26-7.17,2.36-6.2,2-17.64,5.59-18.86,6.82.47,1,2.26,1.49,2.95,1.61a.53.53,0,0,1,.4.39h0s.77,2,8.45,3c3.89.49,10.32.17,16-.11,9.39-.47,12.44-.51,12.63.8A4.76,4.76,0,0,1,342.19,149.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322,134.68s-11.75,5-13.58,6,3.39,3.13,6.53,2.61,15.14-5.23,17-5.75,10.18,1.57,16.19,2.35a20,20,0,0,0,11.23-1.56",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.9,143.88c-2.58,0-5.87-1.16-6.3-2.36a1,1,0,0,1,.57-1.27c1.83-1.05,13.15-5.83,13.63-6a.5.5,0,0,1,.66.27.51.51,0,0,1-.27.65c-.12.05-11.74,5-13.52,6a.47.47,0,0,0-.14.1c.15.57,3.71,2,6.33,1.58,2.07-.34,8.35-2.64,12.5-4.16,2.13-.78,3.81-1.39,4.42-1.57,1.18-.33,4.18.19,9,1.08,2.52.47,5.12,1,7.41,1.26a19.45,19.45,0,0,0,10.94-1.52.5.5,0,0,1,.67.22.49.49,0,0,1-.22.67A20.5,20.5,0,0,1,348,140.4c-2.31-.3-4.93-.79-7.47-1.26-3.69-.69-7.5-1.4-8.51-1.11-.58.17-2.25.78-4.35,1.55-4.44,1.62-10.52,3.85-12.68,4.21A6.72,6.72,0,0,1,313.9,143.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.46,172.78a46.86,46.86,0,0,1-20.16,0c-11-2.45-40-16.81-40-16.81l-19.86-5.8L381,127s50.11,6.11,64.16,11.3,34.52,17.11,33.91,21.39-11.91,13.44-11.91,13.44",
    style: {
      fill: "#0D6EFD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.38,174.35a47,47,0,0,1-10.19-1.09c-10.93-2.43-38.95-16.25-40.14-16.84l-19.77-5.77a.51.51,0,0,1-.35-.58l4.58-23.22a.5.5,0,0,1,.55-.4c.5.06,50.33,6.18,64.27,11.33,13.7,5.06,34.92,17.15,34.24,21.93-.63,4.42-11.63,13.38-12.1,13.76a.5.5,0,0,1-.63-.78c3.1-2.51,11.26-9.77,11.74-13.12.5-3.52-18.34-15.21-33.59-20.85-13.13-4.85-58.5-10.59-63.59-11.22L377,149.81l19.42,5.68c.37.18,29.17,14.39,40,16.8a46.74,46.74,0,0,0,19.93,0,.5.5,0,0,1,.25,1A44.84,44.84,0,0,1,446.38,174.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.38,288.56c-13.57,0-26.74-14.88-27.39-15.63a.5.5,0,1,1,.75-.65c.18.2,18.32,20.7,33.31,13.85s22.81-51.65,22.89-52.1a.51.51,0,0,1,.58-.41.51.51,0,0,1,.41.58c-.32,1.86-7.89,45.73-23.46,52.84A16.81,16.81,0,0,1,311.38,288.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.57,273.79c-18.09,0-31.59-16.59-31.73-16.77a.5.5,0,0,1,.08-.7.49.49,0,0,1,.7.08c.15.18,14.62,18,33.47,16.28,19.27-1.72,25.38-24.57,25.2-34.73a.51.51,0,0,1,.49-.51.53.53,0,0,1,.51.49c.18,10.46-6.14,34-26.11,35.75C293.3,273.76,292.43,273.79,291.57,273.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.5,
    y: 243.5,
    width: 6.48,
    height: 30.38,
    transform: "translate(95.96 -69.57) rotate(18.57)",
    style: {
      fill: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259,274.62a.45.45,0,0,1-.16,0l-6.14-2.06a.48.48,0,0,1-.29-.25.53.53,0,0,1,0-.39L262,243.1a.51.51,0,0,1,.63-.32l6.14,2.07a.48.48,0,0,1,.29.25.5.5,0,0,1,0,.38l-9.68,28.8A.51.51,0,0,1,259,274.62Zm-5.51-2.88,5.19,1.74L268,245.63l-5.19-1.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.9,
    y: 241,
    width: 10.05,
    height: 4.47,
    transform: "translate(91.31 -72.03) rotate(18.57)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270,247.45l-.16,0-9.53-3.2A.49.49,0,0,1,260,244a.5.5,0,0,1,0-.38l1.42-4.24A.51.51,0,0,1,262,239l9.52,3.2a.48.48,0,0,1,.29.25.5.5,0,0,1,0,.38l-1.42,4.24A.5.5,0,0,1,270,247.45Zm-8.89-4,8.58,2.88,1.1-3.28-8.58-2.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.05,
    y: 248.05,
    width: 6.48,
    height: 30.38,
    transform: "translate(98.12 -73.65) rotate(18.57)",
    style: {
      fill: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.52,279.17a.45.45,0,0,1-.16,0l-6.14-2.06a.48.48,0,0,1-.29-.25.46.46,0,0,1,0-.38l9.67-28.8a.48.48,0,0,1,.25-.29.46.46,0,0,1,.38,0l6.14,2.06a.49.49,0,0,1,.32.63L273,278.83A.49.49,0,0,1,272.52,279.17ZM267,276.29l5.2,1.75,9.35-27.85-5.19-1.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.45,
    y: 245.55,
    width: 10.05,
    height: 4.47,
    transform: "translate(93.46 -76.11) rotate(18.57)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.53,252l-.16,0-9.52-3.2a.48.48,0,0,1-.29-.25.5.5,0,0,1,0-.38L275,243.9a.55.55,0,0,1,.26-.28.5.5,0,0,1,.38,0l9.53,3.2a.49.49,0,0,1,.28.25.5.5,0,0,1,0,.38L284,251.66A.5.5,0,0,1,283.53,252Zm-8.89-4,8.58,2.89,1.1-3.29-8.58-2.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.77,
    y: 252.7,
    width: 21,
    height: 23.23,
    transform: "matrix(0.95, 0.32, -0.32, 0.95, 98.04, -71.04)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.52,279.17a.45.45,0,0,1-.16,0l-19.9-6.68a.55.55,0,0,1-.29-.25.53.53,0,0,1,0-.39l7.4-22a.51.51,0,0,1,.25-.29.5.5,0,0,1,.38,0l19.91,6.68a.51.51,0,0,1,.31.64l-7.4,22A.49.49,0,0,1,272.52,279.17Zm-19.27-7.5,19,6.37L279.29,257l-19-6.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "254.32 286.69 235.75 280.45 245.59 264.2 256.28 267.79 254.32 286.69",
    style: {
      fill: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.32,287.19l-.16,0-18.57-6.24a.51.51,0,0,1-.31-.3.5.5,0,0,1,0-.43l9.85-16.26a.49.49,0,0,1,.58-.21l10.69,3.59a.5.5,0,0,1,.34.53l-2,18.89a.49.49,0,0,1-.23.37A.45.45,0,0,1,254.32,287.19Zm-17.82-7L253.89,286l1.86-17.88-9.93-3.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.93,
    y: 283.03,
    width: 19.59,
    height: 20.79,
    transform: "translate(106.03 -61.7) rotate(18.57)",
    style: {
      fill: "#636363"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.7,306.9a.41.41,0,0,1-.16,0L229,300.63a.5.5,0,0,1-.31-.63l6.62-19.71a.49.49,0,0,1,.25-.28.5.5,0,0,1,.38,0l18.57,6.24a.5.5,0,0,1,.31.63l-6.62,19.71a.46.46,0,0,1-.25.28A.43.43,0,0,1,247.7,306.9Zm-17.94-7.06,17.62,5.92L253.69,287l-17.62-5.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.76,
    y: 245.98,
    width: 16.82,
    height: 20.79,
    transform: "translate(94.88 -67.6) rotate(18.57)",
    style: {
      fill: "#636363"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.84,269.4l-.16,0-16-5.36a.51.51,0,0,1-.29-.25.5.5,0,0,1,0-.38L249,243.68a.5.5,0,0,1,.63-.31l15.94,5.35a.55.55,0,0,1,.29.25.53.53,0,0,1,0,.39l-6.62,19.7A.5.5,0,0,1,258.84,269.4Zm-15.31-6.17,15,5,6.3-18.76-15-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "281.42 295.8 262.85 289.56 272.7 273.31 283.39 276.9 281.42 295.8",
    style: {
      fill: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.42,296.3a.45.45,0,0,1-.16,0L262.69,290a.51.51,0,0,1-.31-.3.5.5,0,0,1,.05-.43l9.84-16.25a.51.51,0,0,1,.59-.22l10.69,3.6a.48.48,0,0,1,.33.52l-2,18.9a.51.51,0,0,1-.23.37A.5.5,0,0,1,281.42,296.3Zm-17.82-7L281,295.12l1.86-17.87-9.93-3.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.03,
    y: 292.14,
    width: 19.59,
    height: 20.79,
    transform: "translate(110.35 -69.86) rotate(18.57)",
    style: {
      fill: "#636363"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.8,316l-.16,0-18.57-6.24a.5.5,0,0,1-.31-.63l6.62-19.71a.48.48,0,0,1,.25-.29.46.46,0,0,1,.38,0l18.57,6.23a.52.52,0,0,1,.32.64l-6.62,19.7a.53.53,0,0,1-.26.29A.42.42,0,0,1,274.8,316ZM256.87,309l17.62,5.92,6.3-18.76-17.62-5.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.87,
    y: 255.08,
    width: 16.82,
    height: 20.79,
    transform: "translate(99.19 -75.76) rotate(18.57)",
    style: {
      fill: "#636363"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.94,278.51a.45.45,0,0,1-.16,0l-15.94-5.36a.48.48,0,0,1-.29-.25.5.5,0,0,1,0-.38l6.62-19.7a.5.5,0,0,1,.63-.32l16,5.36a.51.51,0,0,1,.29.25.5.5,0,0,1,0,.38l-6.62,19.71A.49.49,0,0,1,285.94,278.51Zm-15.31-6.17,15,5,6.31-18.75-15-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.2,242.53s-2.16,3.56-1.52,4.58,6.87,4.45,7.76,4.71,3.31-1,3.18-2.68-5-5.21-6.49-6.1S243.84,242,243.2,242.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.7,252.35a1.75,1.75,0,0,1-.4,0c-1-.27-7.32-3.76-8.05-4.93s1-4.21,1.53-5.1a.47.47,0,0,1,.11-.13c1-.76,2-.39,3.49.46.82.48,6.58,4.35,6.74,6.51a2.74,2.74,0,0,1-1.17,2.3A4,4,0,0,1,249.7,252.35Zm-6.12-9.48c-1,1.73-1.73,3.58-1.48,4,.54.87,6.59,4.24,7.48,4.5a2.68,2.68,0,0,0,1.74-.7,1.88,1.88,0,0,0,.8-1.46c-.09-1.23-4.21-4.53-6.24-5.71C244.36,242.58,243.89,242.65,243.58,242.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.78,249.57s-1.05,4-.14,4.83,7.86,2.28,8.79,2.26,2.87-1.93,2.27-3.47-6.26-3.57-8-4S240.24,248.9,239.78,249.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.42,257.16c-1,0-8.08-1.48-9.11-2.39s-.28-4.31,0-5.33a1.11,1.11,0,0,1,.07-.16c.69-1,1.84-.95,3.48-.56.92.22,7.55,2.27,8.33,4.29a2.73,2.73,0,0,1-.45,2.54,3.43,3.43,0,0,1-2.28,1.61Zm-8.18-7.37c-.5,2-.63,3.92-.27,4.23.76.67,7.53,2.18,8.45,2.14a2.62,2.62,0,0,0,1.47-1.17,1.86,1.86,0,0,0,.35-1.62c-.45-1.16-5.35-3.13-7.63-3.67C240.9,249.29,240.47,249.49,240.24,249.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.87,256.57s-1.05,4-.14,4.83,7.86,2.28,8.79,2.26,2.87-1.93,2.27-3.47-6.25-3.57-8-4S238.33,255.9,237.87,256.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.51,264.16c-1,0-8.08-1.48-9.11-2.39s-.28-4.31,0-5.33a.6.6,0,0,1,.08-.16c.68-1,1.83-.95,3.47-.56.92.22,7.55,2.27,8.33,4.29a2.73,2.73,0,0,1-.45,2.54,3.43,3.43,0,0,1-2.28,1.61Zm-8.18-7.37c-.5,2-.63,3.92-.27,4.23.76.67,7.47,2.14,8.44,2.14h0A2.59,2.59,0,0,0,248,262a1.86,1.86,0,0,0,.35-1.62c-.45-1.16-5.35-3.13-7.63-3.67C239,256.29,238.56,256.49,238.33,256.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.76,263.31s-1,4-.14,4.83,7.86,2.28,8.79,2.27,2.87-1.93,2.28-3.48-6.26-3.56-8-4S239.22,262.64,238.76,263.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.4,270.91c-1,0-8.08-1.49-9.11-2.39s-.28-4.31,0-5.33a.48.48,0,0,1,.08-.16c.68-1,1.83-.95,3.47-.56.92.22,7.55,2.26,8.33,4.28a2.75,2.75,0,0,1-.45,2.55,3.43,3.43,0,0,1-2.28,1.61Zm-8.18-7.38c-.5,2-.62,3.93-.27,4.24.76.66,7.48,2.14,8.44,2.14h0a2.59,2.59,0,0,0,1.47-1.17,1.88,1.88,0,0,0,.35-1.63c-.45-1.15-5.35-3.12-7.63-3.67C239.88,263,239.45,263.23,239.22,263.53Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoFoundPage);
export default __webpack_public_path__ + "static/media/no-found-page.a46f01c0fe8ce03388489f747cb50574.svg";
export { ForwardRef as ReactComponent };